import { Report, LessonScreen, ReportedAnswer } from "models/tables";
import { hasText } from "utils/helpers";

export interface StudentStatsPerScreen {
  id: string
  screen?: LessonScreen
  ordinal: number
  durationText: string
  timeStartedText: string
  isCorrect: boolean
  countCorrectAnswers: number
  countIncorrectAnswers: number
  countUnattemptedAnswers: number
  points: number
  answers: ReportedAnswer[]
}

export function computeStudentKey(student: StudentInfo) {
  const parts: string[] = []
  
  if (hasText(student.userId)) {
    parts.push(student.userId!)
  }
  if (hasText(student.name)) {
    parts.push(student.name!)
  }
  
  const key = parts.join('_')
  return key
}

export function emptyStudentStats(): StudentStats {
  return {
    key: '',
    reportId: '',
    name: '',
    userId: '',
    avatar: 0,
    totalPoints: 0,
    successRate: 0,
    countCorrectScreens: 0,
    countIncorrectScreens: 0,
    countUnattemptedScreens: 0,
    totalCountScreensThatCanHaveAnswers: 0,
    percentCorrectScreens: 0,
    percentIncorrectScreens: 0,
    percentUnattemptedScreens: 0,
    screens: []
  }
}

export interface StudentInfo {
  name: string
  userId?: string | null
}

export interface StudentStats {
  key: string
  reportId: string
  
  // summary
  name: string
  userId: string | null
  avatar: number
  totalPoints: number
  successRate: number

  // details
  countCorrectScreens: number
  countIncorrectScreens: number
  countUnattemptedScreens: number
  totalCountScreensThatCanHaveAnswers: number
  percentCorrectScreens: number
  percentIncorrectScreens: number
  percentUnattemptedScreens: number
  screens: StudentStatsPerScreen[]
}

export interface ReportStats {
  report: Report

  students: StudentStats[]
}